import ipadLargest from '../../assets/images/1st header/hero ipad largest.jpg';
import ipadLarge from '../../assets/images/1st header/hero ipad large.jpg';
import ipadSmall from '../../assets/images/1st header/hero ipad small.jpg';
import ipadSmallest from '../../assets/images/1st header/hero ipad smallest.jpg';

import iphoneLargest from '../../assets/images/2nd header/hero iphone largest.jpg';
import iphoneLarge from '../../assets/images/2nd header/hero iphone large.jpg';
import iphoneSmall from '../../assets/images/2nd header/hero iphone small.jpg';
import iphoneSmallest from '../../assets/images/2nd header/hero iphone smallest.jpg';

import iphone14Largest from '../../assets/images/3rd header/hero iphone14 largest.jpg';
import iphone14Large from '../../assets/images/3rd header/hero iphone14 large.jpg';
import iphone14Small from '../../assets/images/3rd header/hero iphone14 small.jpg';
import iphone14Smallest from '../../assets/images/3rd header/hero iphone14 smallest.jpg';

export const heroSectionImages = {
	firstHeroSection: {
		large: ipadLargest,
		medium: ipadLarge,
		small: ipadSmallest,
	},
	secondHeroSection: {
		large: iphoneLargest,
		medium: iphoneLarge,
		small: iphoneSmallest,
	},
	thirdHeroSection: {
		large: iphone14Largest,
		medium: iphone14Large,
		small: iphone14Smallest,
	},
};

// firstHeroSection: {
// 	largest: ipadLargest,
// 	large: ipadLarge,
// 	small: ipadSmall,
// 	smallest: ipadSmallest,
// },
// secondHeroSection: {
// 	largest: iphoneLargest,
// 	large: iphoneLarge,
// 	small: iphoneSmall,
// 	smallest: iphoneSmallest,
// },
// thirdHeroSection: {
// 	largest: iphone14Largest,
// 	large: iphone14Large,
// 	small: iphone14Small,
// 	smallest: iphone14Smallest,
// },
